/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 5H15.9629C15.9973 5 16.0146 5 16.0291 5.00011C18.2155 5.01604 19.984 6.7845 19.9999 8.97085C20 8.98543 20 9.00265 20 9.03711V14.3075C20 14.6392 20.335 14.866 20.643 14.7428V14.7428C21.7646 14.2942 22.5 13.208 22.5 12C22.5 10.7921 21.7646 9.70586 20.6431 9.25724L20 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 2L4.99997 4.99997M21 21L19 19M19 19H8.4C6.15979 19 5.03968 19 4.18404 18.564C3.43139 18.1805 2.81947 17.5686 2.43597 16.8159C2 15.9603 2 14.8402 2 12.6V7.99994C2 6.3431 3.34313 4.99997 4.99997 4.99997V4.99997M19 19L4.99997 4.99997"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 7.99997V12.6C2 14.8402 2 15.9603 2.43597 16.816C2.81947 17.5686 3.43139 18.1805 4.18404 18.564C5.03969 19 6.15979 19 8.4 19H19L4.99997 5C3.34313 5 2 6.34313 2 7.99997Z"
				fill="currentColor"
			/>
			<path
				d="M10 4.99997H15.9628C15.9973 4.99997 16.0146 4.99997 16.0292 5.00008C18.2155 5.01605 19.9839 6.78445 19.9999 8.97074C20 8.98535 20 9.00263 20 9.03719V14.3074C20 14.6391 20.335 14.866 20.643 14.7428V14.7428C21.7646 14.2942 22.5 13.208 22.5 12C22.5 10.7921 21.7646 9.70586 20.6431 9.25724L20 9M2 2L4.99997 4.99997M21 21L19 19M19 19H8.4C6.15979 19 5.03968 19 4.18404 18.564C3.43139 18.1805 2.81947 17.5686 2.43597 16.8159C2 15.9603 2 14.8402 2 12.6V7.99994C2 6.3431 3.34313 4.99997 4.99997 4.99997V4.99997M19 19L4.99997 4.99997"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.53033 1.46967C2.23744 1.17678 1.76257 1.17678 1.46967 1.46967C1.17678 1.76257 1.17678 2.23744 1.46967 2.53033L3.50093 4.56159C2.17601 5.14004 1.25 6.46185 1.25 7.99994L1.25 12.6L1.25 12.633L1.25 12.6331C1.25 13.7252 1.24999 14.5906 1.30699 15.2882C1.36528 16.0016 1.48689 16.6053 1.76772 17.1564C2.22312 18.0502 2.94978 18.7769 3.84355 19.2323C4.39472 19.5131 4.99835 19.6347 5.71174 19.693C6.40935 19.75 7.27485 19.75 8.36698 19.75L8.4 19.75L18.6893 19.75L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L19.5303 18.4696L5.5303 4.46964L2.53033 1.46967ZM10 4.24997C9.58579 4.24997 9.25 4.58576 9.25 4.99997C9.25 5.41419 9.58579 5.74997 10 5.74997L15.9628 5.74997L16.0238 5.75006C17.8001 5.76304 19.2369 7.19987 19.2499 8.97622L19.2499 8.98611C19.2497 8.99595 19.2498 9.00577 19.25 9.01558L19.25 9.03719L19.25 14.3074C19.25 15.1697 20.1209 15.7594 20.9215 15.4392L20.643 14.7428L20.9216 15.4392C22.3279 14.8767 23.25 13.5146 23.25 12C23.25 10.4854 22.3279 9.12341 20.9216 8.56089L20.7219 8.481C20.4644 6.11277 18.4674 4.26788 16.0347 4.2501L15.9663 4.24997L15.9628 4.24997L10 4.24997ZM20.75 13.8462L20.75 10.1538C21.3658 10.5552 21.75 11.2458 21.75 12C21.75 12.7542 21.3658 13.4448 20.75 13.8462Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M10 4.99997H15.9628C15.9973 4.99997 16.0146 4.99997 16.0292 5.00008C18.2155 5.01605 19.9839 6.78445 19.9999 8.97074C20 8.98535 20 9.00263 20 9.03719V14.3074C20 14.6391 20.335 14.866 20.643 14.7428V14.7428C21.7646 14.2942 22.5 13.208 22.5 12C22.5 10.7921 21.7646 9.70586 20.6431 9.25724L20 9M2 2L4.99997 4.99997M21 21L19 19M19 19L4.99997 4.99997M19 19H12.5H12M4.99997 4.99997V4.99997C3.34313 4.99997 2 6.3431 2 7.99994V13.5C2 14.8955 2 15.5933 2.17224 16.1611C2.56004 17.4395 3.56046 18.4399 4.83886 18.8277C5.40666 19 6.10444 19 7.5 19V19H8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M10 4.99997H15.9628C15.9973 4.99997 16.0146 4.99997 16.0292 5.00008C18.2155 5.01605 19.9839 6.78445 19.9999 8.97074C20 8.98535 20 9.00263 20 9.03719V14.3074C20 14.6391 20.335 14.866 20.643 14.7428V14.7428C21.7646 14.2942 22.5 13.208 22.5 12C22.5 10.7921 21.7646 9.70586 20.6431 9.25724L20 9M2 2L4.99997 4.99997M21 21L19 19M19 19H8.4C6.15979 19 5.03968 19 4.18404 18.564C3.43139 18.1805 2.81947 17.5686 2.43597 16.8159C2 15.9603 2 14.8402 2 12.6V7.99994C2 6.3431 3.34313 4.99997 4.99997 4.99997V4.99997M19 19L4.99997 4.99997"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M5.31051 4.25C3.06788 4.25 1.24988 6.06801 1.24988 8.31063L1.24988 12C1.24988 14.5647 1.24988 15.847 1.70916 16.8433C2.20758 17.9245 3.07542 18.7923 4.15658 19.2907C5.15284 19.75 6.43519 19.75 8.99988 19.75L20.8105 19.75L5.31051 4.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.46967 1.46967C1.76256 1.17678 2.23744 1.17678 2.53033 1.46967L5.5303 4.46964L19.5303 18.4696L21.5303 20.4697C21.8232 20.7626 21.8232 21.2374 21.5303 21.5303C21.2374 21.8232 20.7626 21.8232 20.4697 21.5303L18.4696 19.5303L4.46964 5.5303L1.46967 2.53033C1.17678 2.23744 1.17678 1.76256 1.46967 1.46967ZM9.25 4.99997C9.25 4.58576 9.58579 4.24997 10 4.24997L15.9628 4.24997L15.9663 4.24997C15.9975 4.24997 16.0173 4.24997 16.0347 4.2501C18.4674 4.26788 20.4644 6.11277 20.7219 8.481L20.9216 8.56088C22.3279 9.12341 23.25 10.4854 23.25 12C23.25 13.5146 22.3278 14.8767 20.9216 15.4392L20.643 14.7428L20.9215 15.4392C20.1209 15.7594 19.25 15.1697 19.25 14.3074L19.25 9.03719L19.25 9.01558C19.2498 9.00577 19.2497 8.99595 19.2499 8.98611L19.2499 8.97622C19.2369 7.19986 17.8001 5.76304 16.0238 5.75006L15.9628 5.74997L10 5.74997C9.58579 5.74997 9.25 5.41418 9.25 4.99997ZM20.75 10.1538L20.75 13.8462C21.3658 13.4448 21.75 12.7542 21.75 12C21.75 11.2458 21.3658 10.5552 20.75 10.1538Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
